// SEO / meta 标签写入统一工具
//
// 收敛 main.js 的 updateInitialMetaTags 与 TagPage 的 updateMetaInfo 中重复的 meta 操作，
// 并修正 TagPage 原先「非 zh 一律 en_US」导致的 ja/ko og:locale 错标。
// 仅操作 DOM（document），不依赖任何 Vue 实例，纯函数式可被任意页面/守卫复用。

// locale（如 'zh'）→ Open Graph 地区码（如 'zh_CN'）。未知 locale 回退 en_US。
const OG_LOCALE_MAP = {
  zh: 'zh_CN',
  ja: 'ja_JP',
  ko: 'ko_KR',
};

export function localeToOgLocale(locale) {
  return OG_LOCALE_MAP[locale] || 'en_US';
}

// 设置单个 meta 标签内容（name 或 property）。标签不存在时静默跳过（与历史行为一致）。
export function setMetaTag(name, content, attributeName = 'name') {
  const meta = document.querySelector(`meta[${attributeName}="${name}"]`);
  if (meta) {
    meta.setAttribute('content', content);
  }
}

// 设置 og:locale（含正确的地区码映射，修正 ja/ko 被标成 en_US 的问题）
export function setOgLocale(locale) {
  setMetaTag('og:locale', localeToOgLocale(locale), 'property');
}

// 设置 canonical 链接 href（标签不存在时静默跳过）
export function setCanonical(href) {
  const link = document.querySelector('link[rel="canonical"]');
  if (link) {
    link.setAttribute('href', href);
  }
}

// 写入 JSON-LD 结构化数据（script[type="application/ld+json"] 不存在时静默跳过）
export function setStructuredData(obj) {
  const script = document.querySelector('script[type="application/ld+json"]');
  if (script) {
    script.textContent = JSON.stringify(obj);
  }
}
